/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-empty */
/* eslint-disable eqeqeq */
/* eslint-disable no-shadow */
/* eslint-disable react/destructuring-assignment */
import {
  ArrowDownOutlined,
  ArrowsAltOutlined,
  ArrowUpOutlined,
  DownOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Dropdown,
  Input,
  List,
  Menu,
  message,
  Popover,
  Radio,
  Row,
  Select,
  Spin,
  Statistic,
  Tabs,
} from "antd";
import dayjs from "dayjs";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Emoji from "react-emoji-render";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip as ReTooltip,
  XAxis,
} from "recharts";
import CartesianGrid from "recharts/lib/cartesian/CartesianGrid";
import YAxis from "recharts/lib/cartesian/YAxis";
import Legend from "recharts/lib/component/Legend";

import { getSupaClient } from "../../lib/supabase";
import {
  setInsightsActiveChannels,
  setInsightsActiveMembers,
  setInsightsActivityCount,
  setInsightsAverageMembers,
  setInsightsAverageReplies,
  setInsightsEngagementMetrics,
  setInsightsMessagesData,
  setInsightsTtfr,
  setInsightsWeeklyMessages,
} from "../../redux/actions";
import ChannelDetail from "../ChannelDetail/ChannelDetail";
import RenderLineChart from "../Charts/RenderLineChart";
import ChannelSelector from "../common/ChannelSelector";
import Companies from "../Companies";
import { useEndTime, useStartTime } from "../DateContext/DateContext";
import DateRangePicker from "../DateRangePicker/DateRangePicker";
// import { DateProvider } from "../DateContext/DateContext";
import DynamicKeywords from "../DynamicKeywords/DynamicKeywords";
import SelectedKeywords from "../DynamicKeywords/SelectedKeywords";
import EngagementCard from "../EngagementCard/EngagementCard";
import MembersOverTimeCard from "../MembersOverTimeCard/MembersOverTimeCard";
import TopPosts from "./TopPosts";

const { Option } = Select;
const { TabPane } = Tabs;
const defaultTimeFormat = "YYYY-MM-DDTHH:mm:ssZ";

const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
// dependent on utc plugin
dayjs.extend(utc);
dayjs.extend(timezone);

const dateFormat = "MM/DD/YY";

const SlackInsightsPage = () => {
  const supabase = getSupaClient();
  const teamId = localStorage.getItem("team-id");
  const dispatch = useDispatch();
  const weeklyMessageCount = useSelector(
    (state) => state.insights.weekly_messages
  );
  const messagesCount = useSelector((state) => state.insights.messages_data);
  const averageReplies = useSelector((state) => state.insights.average_replies);
  const ttfr = useSelector((state) => state.insights.ttfr);
  const activeChannels = useSelector((state) => state.insights.active_channels);
  const activeMembersCount = useSelector(
    (state) => state.insights.active_members
  );
  const averageMembersCount = useSelector(
    (state) => state.insights.average_members
  );
  const activityCountData = useSelector(
    (state) => state.insights.activity_count
  );
  const engagementMetrics = useSelector(
    (state) => state.insights.engagement_metrics
  );

  const engagementMetricsDefault = {
    currentActive: "-",
    previousActive: "-",
    currentMessage: "-",
    previousMessage: "-",
    loading: true,
  };

  const [loadingPost, setLoadingPost] = useState(false);
  const [loadingFirstReply, setLoadingFirstReply] = useState(false);
  const [loadingAvgReply, setLoadingAvgReply] = useState(false);
  const [loadingMembersCount, setLoadingMembersCount] = useState(false);
  const [loadingActivityCount, setLoadingActivityCount] = useState(false);
  const [loadingActiveMembers, setLoadingActiveMembers] = useState(false);
  const [loadingChannels, setLoadingChannels] = useState(false);
  const { startTime, setStartTime } = useStartTime();
  const { endTime, setEndTime } = useEndTime();
  const [groupBy, setGroupBy] = useState("day");
  const [includeOptions, setIncludeOptions] = useState("include");
  const [inActiveChannels, setInActiveChannels] = useState([]);
  const [dropdownText, setDropdownText] = useState("Day");
  const [expandActiveMembers, setExpandActiveMembers] = useState(false);
  const [expandEngagement, setExpandEngagement] = useState(false);
  const [currentChannel, setCurrentChannel] = useState("");

  const [activeChannelRadio, setActiveChannelRadio] = useState(true);
  const [expandMembersOverTime, setExpandMembersOverTime] = useState(false);

  window.moment = moment;

  // let params = props
  const navigate = useNavigate();

  const channelToggle = (e) => {
    // console.log('radio4 checked', e.target.value);
    setActiveChannelRadio(e.target.value);
  };

  const loadMessagesData = async (startTime, endTime) => {
    setLoadingPost(true);
    const params = {
      end_time: endTime,
      start_time: startTime,
      team_id: teamId,
      group_by: groupBy,
      time_zone: dayjs.tz.guess(),
    };

    const { data } = await supabase.rpc("messages_count_average", params);
    if (data) {
      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      if (groupBy == "day") {
        const arr = [];
        days.map((day) => {
          let dayRecord = data.find((item) => {
            return item.time_period.toLowerCase().includes(day.toLowerCase());
          });
          // eslint-disable-next-line
          const time_period = dayRecord && dayRecord.time_period.slice(0, 3);
          dayRecord = { ...dayRecord, time_period };

          if (dayRecord !== undefined) arr.push(dayRecord);
          return dayRecord;
        });

        dispatch(setInsightsMessagesData(arr));
      } else {
        dispatch(setInsightsMessagesData(data));
      }
    }
    setLoadingPost(false);
  };

  const loadActiveChannels = async (startTime, endTime) => {
    setLoadingChannels(true);
    const params = {
      start_time: startTime,
      end_time: endTime,
      team_id: teamId,
    };
    const { data, error } = await supabase.rpc("active_channels", params);

    if (error) console.error(error);
    if (data) {
      dispatch(setInsightsActiveChannels(data));
    }

    const inactive = await supabase.rpc("inactive_channels", params);
    if (inactive.data) {
      setInActiveChannels(inactive.data);
    }
    setLoadingChannels(false);
    return data;
  };

  const loadActiveMemberCounts = async (startTime, endTime) => {
    setLoadingActiveMembers(true);
    const params = {
      start_time: startTime,
      end_time: endTime,
      team_id: teamId,
    };
    const { data, error } = await supabase.rpc(
      "active_users_count_timeperiod",
      params
    );

    if (error) console.error(error);
    if (data) {
      console.log("active members data", data);
      dispatch(setInsightsActiveMembers(data));
      setLoadingActiveMembers(false);
    }
    return data;
  };

  // Load average number of members that responded to a post
  const loadAverageMemberCounts = async (startTime, endTime) => {
    setLoadingMembersCount(true);
    const params = {
      start_time: startTime,
      end_time: endTime,
      team_id: teamId,
    };
    const { data, error } = await supabase.rpc("average_user_count", params);

    if (error) console.error(error);
    if (data) {
      console.log("average members data", data);
      dispatch(setInsightsAverageMembers(data));
      setLoadingMembersCount(false);
    }
    return data;
  };

  const loadActivityCountDailyData = async (startTime, endTime) => {
    setLoadingActivityCount(true);
    const params = {
      end_time: endTime,
      start_time: startTime,
      team_id: teamId,
      options: includeOptions,
      time_zone: dayjs.tz.guess(),
    };

    const { data } = await supabase.rpc("activity_count_daily", params);
    if (data) {
      dispatch(setInsightsActivityCount(data));
    }
    setLoadingActivityCount(false);
  };

  const handleChangeGroup = (e) => {
    if (e.key == "Day") {
      setGroupBy("day");
      setDropdownText("Day");
    } else if (e.key == "Hour") {
      setGroupBy("hour");
      setDropdownText("Hour");
    }
  };

  const prepareTtfr = async (startTime, endTime) => {
    const params = {
      start_time: startTime,
      end_time: endTime,
      team_id: teamId,
    };
    const { data, error } = await supabase.rpc("average_ttfr_overall", params);

    if (error) console.error(error);

    const average = await supabase.rpc("average_ttfr_overall_avg", params);

    if (average.error) console.error("error", average.error);

    return {
      data,
      average: average.data,
    };
  };

  const loadTtfr = async (startTime, endTime) => {
    setLoadingFirstReply(true);

    const res = await prepareTtfr(startTime, endTime);
    // console.log("initial ttfr", res)
    if (res.data && res.average) {
      // setup the average line chart array based on average array received
      const results = res.data.map((item) => {
        return {
          ...item,
          current_avg: res.average[0].average,
          previous_avg: res.average[1].average,
        };
      });

      dispatch(setInsightsTtfr({ results }));
    }
    setLoadingFirstReply(false);
    return res;
  };

  const prepareAverageReplies = async (startTime, endTime) => {
    const params = {
      start_time: startTime,
      end_time: endTime,
      team_id: teamId,
    };
    const { data, error } = await supabase.rpc(
      "average_replies_overall",
      params
    );
    if (error) console.error(error);

    const average = await supabase.rpc("average_replies_overall_avg", params);

    if (average.error) console.error("error", average.error);
    console.log("updating average", startTime, endTime);
    return {
      data,
      average: average.data,
    };
  };

  const loadAverageReplies = async (startTime, endTime) => {
    // const endDate = dayjs(endTime).add(1, "day").format(dateFormat);
    setLoadingAvgReply(true);

    const res = await prepareAverageReplies(startTime, endTime);
    console.log("result av", res);
    if (res.data && res.average) {
      const results = res.data.map((item) => {
        return {
          ...item,
          current_avg: res.average[0].average,
          previous_avg: res.average[1].average,
        };
      });
      dispatch(setInsightsAverageReplies({ results }));
    }
    setLoadingAvgReply(false);

    return res;
  };

  const loadPageData = async (startTime, endTime) => {
    await loadActiveMemberCounts(startTime, endTime);
    await loadActivityCountDailyData(startTime, endTime);

    await loadMessagesData(startTime, endTime);
    await loadAverageMemberCounts(startTime, endTime);
    // loadEngagement(startTime, endTime);
    await loadAverageReplies(startTime, endTime);
    await loadActiveChannels(startTime, endTime);
    await loadTtfr(startTime, endTime);
  };

  const loadInitialData = async (startTime, endTime) => {
    if (activeMembersCount.length === 0) {
      await loadActiveMemberCounts(startTime, endTime);
    }
    if (activityCountData.length === 0) {
      await loadActivityCountDailyData(startTime, endTime);
    }

    if (messagesCount.length === 0) {
      await loadMessagesData(startTime, endTime);
    }
    if (averageMembersCount.length === 0) {
      await loadAverageMemberCounts(startTime, endTime);
    }
    // if (engagementMetrics.loading) {
    //   loadEngagement(startTime, endTime);
    // }
    if (averageReplies.results.length === 0) {
      await loadAverageReplies(startTime, endTime);
    }
    if (activeChannels.length === 0) {
      await loadActiveChannels(startTime, endTime);
    }
    if (ttfr.results.length === 0) {
      await loadTtfr(startTime, endTime);
    }
  };

  useEffect(() => {
    loadMessagesData(startTime, endTime);
  }, [groupBy]);

  useEffect(() => {
    loadActivityCountDailyData(startTime, endTime);
  }, [includeOptions]);

  useEffect(() => {
    loadInitialData(startTime, endTime);
    document.title = "Insights | Dots";
  }, []);

  const CustomTooltip = ({ active, payload, label }) => {
    // console.log("tool", payload[0], payload, label)
    if (active && payload && payload.length) {
      // console.log("payload,", payload[0].current)
      return (
        <div
          className="custom-tooltip"
          style={{ background: "rgba(76, 175, 80, 0.3)" }}
        >
          <p className="label">
            {`${label} : ${payload[0].value} `}
            {payload[0].payload.label ? "(Ongoing)" : ""}
          </p>
        </div>
      );
    }

    return null;
  };

  const handleChangeCheckBox = (e) => {
    const value = e.target.checked;
    if (value) {
      setIncludeOptions("exclude");
    } else {
      setIncludeOptions("include");
    }
  };

  const menu = (
    <Menu onClick={handleChangeGroup}>
      <Menu.Item key="Day">Day</Menu.Item>
      <Menu.Item key="Hour">Hour</Menu.Item>
    </Menu>
  );

  const popupContent = (text) => (
    <div>
      <p>{text}</p>
    </div>
  );

  return (
    <div>
      <Tabs
        defaultActiveKey="1"
        tabBarExtraContent={
          <DateRangePicker
            loadPageData={loadPageData}
            customOption={{ disabled: false }}
            rangeOfSelector={{
              range: "day",
              selectorDefaultOptions: [
                { value: 7, disabled: false },
                {
                  value: 30,
                  disabled: false,
                },
              ],
            }}
          />
        }
      >
        <TabPane tab="Overview" key="1" style={{ paddingTop: 20 }}>
          <Row gutter={[32, 32]} style={{ marginBottom: 50 }}>
            <Col lg={24}>
              <EngagementCard teamId={teamId} span={6} />
            </Col>
            <Col lg={expandActiveMembers ? 24 : 12} md={24}>
              <Card
                title="Active members over time"
                bordered={false}
                extra={
                  <>
                    <Button
                      onClick={() =>
                        setExpandActiveMembers(!expandActiveMembers)
                      }
                    >
                      <div className="-mt-1">
                        <ArrowsAltOutlined />
                      </div>
                    </Button>
                    <Popover
                      content={popupContent(
                        "Members that posted a message or sent an emoji reaction in a public channel, over time."
                      )}
                      className="ml-3"
                    >
                      <InfoCircleOutlined />
                    </Popover>
                  </>
                }
              >
                <Spin spinning={loadingActiveMembers}>
                  <div
                    style={{
                      width: "100%",
                      height: expandActiveMembers ? "500px" : "250px",
                    }}
                  >
                    <ResponsiveContainer>
                      <LineChart
                        width={430}
                        data={activeMembersCount}
                        margin={{
                          top: 5,
                          right: 5,
                          left: 0,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis
                          dataKey="for_date"
                          tickFormatter={(date) => {
                            return moment(date).format("MM/DD");
                          }}
                        />
                        <YAxis domain={["auto", "auto"]} />
                        <Legend />
                        <ReTooltip />
                        <Line
                          type="monotone"
                          dataKey="total_count"
                          name="# of active members"
                          stroke="#8884d8"
                          activeDot={{ r: 8 }}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </Spin>
              </Card>
            </Col>
            <Col lg={expandEngagement ? 24 : 12} md={24}>
              <Card
                title="What is the engagement?"
                bordered={false}
                extra={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {expandEngagement ? (
                      <Button
                        className="mr-3"
                        onClick={() => message.info("Coming soon!")}
                      >
                        Group by month
                      </Button>
                    ) : null}
                    <Checkbox onChange={handleChangeCheckBox}>
                      <span className="text-gray-500">
                        Exclude thread messages
                      </span>
                    </Checkbox>
                    <Button
                      onClick={() => setExpandEngagement(!expandEngagement)}
                    >
                      <div className="-mt-1">
                        <ArrowsAltOutlined />
                      </div>
                    </Button>
                    <Popover
                      content={popupContent(
                        "Number of messages and emoji reactions in public channels, over time."
                      )}
                      className="ml-3"
                    >
                      <InfoCircleOutlined />
                    </Popover>
                  </div>
                }
              >
                <Spin spinning={loadingActivityCount}>
                  <div
                    style={{
                      width: "100%",
                      height: expandEngagement ? "500px" : "250px",
                    }}
                  >
                    <ResponsiveContainer>
                      <LineChart
                        width={430}
                        data={activityCountData}
                        margin={{
                          top: 5,
                          right: 5,
                          left: 0,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis
                          dataKey="date_day"
                          tickFormatter={(date) => moment(date).format("MM/DD")}
                        />
                        <YAxis domain={["auto", "auto"]} />
                        <Legend />
                        <ReTooltip />
                        <Line
                          type="monotone"
                          dataKey="count_messages"
                          name="# of messages"
                          stroke="#8884d8"
                          activeDot={{ r: 8 }}
                        />
                        <Line
                          type="monotone"
                          dataKey="count_reaction"
                          name="# of reactions"
                          stroke="#FFC658"
                          activeDot={{ r: 8 }}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </Spin>
              </Card>
            </Col>
            <Col lg={12} md={24}>
              <Card
                title="When to post?"
                bordered={false}
                extra={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <h2 style={{ marginRight: 10 }}>Group By</h2>
                    <Dropdown className="joyride-date" overlay={menu}>
                      <Button>
                        {dropdownText} <DownOutlined />
                      </Button>
                    </Dropdown>
                    <Popover
                      content={popupContent(
                        "Average number of messages sent in public channels, by day of week or hour of the day."
                      )}
                      className="ml-3"
                    >
                      <InfoCircleOutlined />
                    </Popover>
                  </div>
                }
              >
                <Spin spinning={loadingPost}>
                  <div
                    style={{
                      width: "100%",
                      height: "250px",
                      // paddingBottom: 10,
                    }}
                  >
                    <ResponsiveContainer>
                      <LineChart
                        width={430}
                        data={messagesCount}
                        margin={{
                          top: 5,
                          right: 5,
                          left: 0,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis dataKey="time_period" />
                        <YAxis dataKey="avg" domain={["auto", "auto"]} />
                        <Legend />
                        <ReTooltip />
                        <Line
                          type="monotone"
                          name="number of avg. messages sent (public channels)"
                          dataKey="avg"
                          stroke="#8884d8"
                          activeDot={{ r: 8 }}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: 20,
                      }}
                    >
                      {groupBy == "hour" ? (
                        <div>Timezone : {dayjs.tz.guess()}</div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </Spin>
              </Card>
            </Col>
            <Col lg={12} md={24}>
              <DynamicKeywords startTime={startTime} endTime={endTime} />
            </Col>
          </Row>
          <Row gutter={[32, 32]} style={{ marginBottom: 20 }}>
            <Col span={24}>
              <h1>More charts</h1>
            </Col>
            <Col lg={12} md={24}>
              <Card
                title="Average replies (per thread)"
                bordered={false}
                extra={
                  <Popover
                    content={popupContent(
                      "Average number of messages sent in public channels threads, over time."
                    )}
                    className="ml-3"
                  >
                    <InfoCircleOutlined />
                  </Popover>
                }
              >
                <Spin spinning={loadingAvgReply}>
                  <div style={{ width: "100%", height: "250px" }}>
                    {averageReplies.results ? (
                      <RenderLineChart
                        data={averageReplies.results}
                        average
                        dataline="avg_reply_count"
                        dataline_name="Avg reply count"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </Spin>
              </Card>
            </Col>

            <Col lg={12} md={24}>
              <Card
                style={{ marginBottom: 40 }}
                title="Channel activity"
                bordered={false}
                extra={
                  <Radio.Group
                    buttonStyle="solid"
                    size="small"
                    defaultValue
                    value={activeChannelRadio}
                    onChange={channelToggle}
                  >
                    <Radio.Button value>Active</Radio.Button>
                    <Radio.Button value={false}>Inactive</Radio.Button>
                  </Radio.Group>
                }
              >
                {activeChannelRadio
                  ? ""
                  : "Channels with no messages (in selected time period)"}
                <Spin spinning={loadingPost}>
                  <List
                    className="popular-channels"
                    dataSource={
                      activeChannelRadio ? activeChannels : inActiveChannels
                    }
                    renderItem={(item) => (
                      <List.Item>
                        <List.Item.Meta
                          title={
                            <a
                              // href={`/channel/${item.channel_id}`}
                              onKeyDown={() =>
                                navigate(`/channel/${item.channel_id}`)
                              }
                              onClick={() =>
                                navigate(`/channel/${item.channel_id}`)
                              }
                              role="button"
                              tabIndex={0}
                            >
                              #{item.channel_name}
                            </a>
                          }
                        />
                        {activeChannelRadio ? (
                          <div>
                            {item.num} {item.num > 1 ? "messages" : "message"}
                          </div>
                        ) : (
                          ""
                        )}
                      </List.Item>
                    )}
                  />
                </Spin>
              </Card>
            </Col>
            <Col lg={12} md={24}>
              <TopPosts
                startTime={startTime}
                endTime={endTime}
                platform="slack"
              />
            </Col>
            <Col lg={12} md={24}>
              <Card
                title="Number of members who replied to a post"
                bordered={false}
                extra={
                  // <Checkbox onChange={handleChangeCheckBox}>
                  //   <span className="text-gray-500">
                  //     Exclude replies to own post
                  //   </span>
                  // </Checkbox>
                  <Popover
                    content={popupContent(
                      "Average number of members who responded to a thread, over time."
                    )}
                    className="ml-3"
                  >
                    <InfoCircleOutlined />
                  </Popover>
                }
              >
                <Spin spinning={loadingMembersCount}>
                  <div
                    style={{
                      width: "100%",
                      height: "250px",
                    }}
                  >
                    <ResponsiveContainer>
                      <LineChart
                        width={430}
                        data={averageMembersCount}
                        margin={{
                          top: 5,
                          right: 5,
                          left: 0,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis
                          dataKey="for_date"
                          tickFormatter={(date) => {
                            return moment(date).format("MM/DD");
                          }}
                        />
                        <YAxis domain={["auto", "auto"]} />
                        <Legend />
                        <ReTooltip />
                        <Line
                          type="monotone"
                          dataKey="avg_user_count"
                          name="Average # of members who responded to a post"
                          stroke="#8884d8"
                          activeDot={{ r: 8 }}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </Spin>
              </Card>
              {/* <Col lg={expandMembersOverTime ? 24 : 12} md={24}> */}
              <MembersOverTimeCard
                style={{ marginTop: 20 }}
                teamId={teamId}
                span={24}
                expandMembersOverTime={expandMembersOverTime}
                setExpandMembersOverTime={setExpandMembersOverTime}
              />
              {/* </Col> */}
            </Col>

            <Col lg={12} md={24}>
              <Card
                title="Time to first reply (hrs)"
                bordered={false}
                extra={[]}
              >
                <Spin spinning={loadingFirstReply}>
                  <div style={{ width: "100%", height: "250px" }}>
                    {averageReplies.results ? (
                      <RenderLineChart
                        data={ttfr.results}
                        average
                        dataline="avg_ttfr"
                        dataline_name="Time to first reply"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </Spin>
              </Card>
            </Col>
            <Col lg={12} md={24}>
              <SelectedKeywords startTime={startTime} endTime={endTime} />
            </Col>
          </Row>
        </TabPane>
        <TabPane tab="Channels" key="3" style={{ paddingY: 20 }}>
          <ChannelSelector
            platform="slack"
            handleChannelSelection={setCurrentChannel}
          />
          <ChannelDetail channelId={currentChannel.slack_id} />
        </TabPane>
        <TabPane tab="Companies" key="2" style={{ paddingTop: 20 }}>
          <Companies />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default SlackInsightsPage;
